import { from, Observable, throwError } from "rxjs";
import backend from "./axios.functions";
import { catchError, map } from "rxjs/operators";
import { createError } from "../redux/actions/errorHandlingAction";
import { AxiosInstance, AxiosResponse } from "axios";

export function get<T>(url: string, payload?: any): Observable<T> {
  return request(backend.get, url, payload);
}

export function post<T>(url: string, payload: any): Observable<T> {
  return request(backend.post, url, payload);
}

export function put<T>(url: string, payload?: any): Observable<T> {
  return request(backend.put, url, payload);
}

export function patch<T>(url: string, payload: any): Observable<T> {
  return request(backend.patch, url, payload);
}

export function del<T>(url: string): Observable<T> {
  return request(backend.delete, url);
}

function request<T>(axiosMethod: (...args: any[]) => any, ...args: any[]): Observable<T> {
  return from(axiosMethod(...args)).pipe(
    map((response) => (response as AxiosResponse<T>).data),
    catchError((error) => throwError(createError(error)))
  );
}

export function getAxiosInstance(): AxiosInstance {
  return backend;
}
